import { Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { TFunction } from 'i18next';
import React, { FC } from 'react';
import { formatMoney } from 'utils/helpers';
import { AccountedBy } from 'v2-types/order';

type accocuntedforprops = {
  accountedInfo: AccountedBy[];
  isFaked: boolean;
  t: TFunction;
};

const useStyles = makeStyles((theme: any) => ({ divider: { marginBottom: theme.spacing(1) } }));

const AccountedFor: FC<accocuntedforprops> = ({ accountedInfo, isFaked, t }) => {
  const classes = useStyles();
  return (
    <Box display="flex" flexDirection="column">
      {accountedInfo?.map((accounted) => (
        <Box
          display="flex"
          flexDirection="column"
          className={classes.divider}
          key={`${accounted.amount}${accounted.record.description}`}
        >
          <Box>
            {isFaked && <Typography variant="subtitle2">{t('accounting:faked')}</Typography>}
            {`* ${accounted.record.description}`}
          </Box>
          {isFaked ? (
            <Box>{`${formatMoney(accounted.record.amount_faked as number)}`}</Box>
          ) : (
            <Box>{`${formatMoney(accounted.amount)}`}</Box>
          )}
        </Box>
      ))}
    </Box>
  );
};

export default AccountedFor;
